export default __webpack_public_path__ + "static/media/datatables.20836ea0.png";